export default __webpack_public_path__ + "static/media/logo_mobile.295ea12f.svg";